import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=9c3bb58e&"
import script from "./ShippingAddress.vue?vue&type=script&lang=ts&"
export * from "./ShippingAddress.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=9c3bb58e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports